import React from 'react';
import PropTypes from "prop-types";
import WidgetUtils from "../utils/WidgetUtils";
import DisplayNameConfigField from "./fields/DisplayNameConfigField";
import { I18n } from "react-redux-i18n";
import TextConfigField from "./fields/TextConfigField";
import InterfaceSelectorConfigFieldContainer from "../containers/fields/InterfaceSelectorConfigFieldContainer";
import UrlConfigField from "./fields/UrlConfigField";
import ChartSeriesConfigFieldContainer from '../containers/fields/ChartSeriesConfigFieldContainer';
import CheckboxConfigFieldContainer from "../containers/fields/CheckboxConfigFieldContainer";

const WidgetConfigField = ({
    fieldConfig,
    handleOnFieldBlur,
    handleFieldChange,
    formData,
}) => {
    switch (fieldConfig.name) {
        case WidgetUtils.WidgetConfigFieldType.DISPLAY_NAME:
            return <DisplayNameConfigField
                name={fieldConfig.name}
                value={formData[fieldConfig.name] ? formData[fieldConfig.name].value : undefined}
                fieldConfig={fieldConfig}
                placeHolder={I18n.t("generic.widgets.displayNamePlaceHolder")}
                handleFieldChange={handleFieldChange}
                handleOnFieldBlur={handleOnFieldBlur}
            />;
        case WidgetUtils.WidgetConfigFieldType.INTERFACE_SELECTOR:
            return <InterfaceSelectorConfigFieldContainer
                name={fieldConfig.name}
                formData={formData}
                fieldConfig={fieldConfig}
                handleFieldChange={handleFieldChange}
            />;
        case WidgetUtils.WidgetConfigFieldType.TEXT:
            return <TextConfigField
                name={fieldConfig.name}
                value={formData[fieldConfig.name] ? formData[fieldConfig.name].value : undefined}
                fieldConfig={fieldConfig}
                handleFieldChange={handleFieldChange}
                handleOnFieldBlur={handleOnFieldBlur}
            />;
        case WidgetUtils.WidgetConfigFieldType.URL:
            return <UrlConfigField
                name={fieldConfig.name}
                value={formData[fieldConfig.name] ? formData[fieldConfig.name].value : undefined}
                fieldConfig={fieldConfig}
                handleFieldChange={handleFieldChange}
                handleOnFieldBlur={handleOnFieldBlur}
            />;
        case WidgetUtils.WidgetConfigFieldType.CHART_SERIES_SELECTOR:
            return <ChartSeriesConfigFieldContainer
                name={fieldConfig.name}
                value={formData[fieldConfig.name] ? formData[fieldConfig.name].value : undefined}
                fieldConfig={fieldConfig}
                handleFieldChange={handleFieldChange}
                handleOnFieldBlur={handleOnFieldBlur}
            />;
        case WidgetUtils.WidgetConfigFieldType.CHECKBOX:
            return <CheckboxConfigFieldContainer
                labels={fieldConfig.labels}
                formData={formData}
                checkboxGroupId={fieldConfig.checkboxId}
                checkboxGroupTitle={fieldConfig.title}
                maxChecked={fieldConfig.maxChecked}
                handleFieldChange={handleFieldChange}
                hasSelectAll={fieldConfig.hasSelectAll}
            />;
        default:
            throw new Error("Invalid widget config field type: " + fieldConfig.name);
    }
};

WidgetConfigField.propTypes = {
    fieldConfig: PropTypes.object,
    handleOnFieldBlur: PropTypes.func,
    handleFieldChange: PropTypes.func,
    formData: PropTypes.object,
};

export default WidgetConfigField;